import "core-js";
import "regenerator-runtime/runtime";
import { COMMIT_HASH, CONFIGCAT_SDK_KEY } from "./config";
import { ENTRY } from "./helpers/entry";
import type { RenderShellOpts } from "./renderShell";
import { type UniversalBootstrapOpts } from "./universalBootstrap";

const ENGAGE_BOOTSTRAP_OPTS: UniversalBootstrapOpts = {
  featureFlagClientKey: CONFIGCAT_SDK_KEY,
  projectIdHeader: true,
  googleTagManager: true,
  exceptionMonitoring: true,
  messageMediaThemes: false,
  patchRequestsWithAuth: true,
  requireCriticalBrowserSupport: true,
  rudderstack: false,
  setDefaultLanguageToBrowserDefault: false,
};

const MM_BOOTSTRAP_OPTS: UniversalBootstrapOpts = {
  featureFlagClientKey: CONFIGCAT_SDK_KEY,
  projectIdHeader: false,
  googleTagManager: true,
  exceptionMonitoring: false,
  messageMediaThemes: true,
  patchRequestsWithAuth: false,
  requireCriticalBrowserSupport: false,
  rudderstack: true,
  setDefaultLanguageToBrowserDefault: true,
};

const COP_BOOTSTRAP_OPTS: UniversalBootstrapOpts = {
  featureFlagClientKey: CONFIGCAT_SDK_KEY,
  projectIdHeader: false,
  googleTagManager: false,
  exceptionMonitoring: false,
  messageMediaThemes: false,
  patchRequestsWithAuth: false,
  requireCriticalBrowserSupport: true,
  rudderstack: false,
  setDefaultLanguageToBrowserDefault: false,
};

const loadBootstrap = async () => {
  const { universalBootstrap } = await import(
    /* webpackPreload: true */ "./universalBootstrap"
  );
  if (ENTRY === "engage") {
    await universalBootstrap(ENGAGE_BOOTSTRAP_OPTS);
  } else if (ENTRY === "mm") {
    await universalBootstrap(MM_BOOTSTRAP_OPTS);
  } else if (ENTRY === "cop") {
    await universalBootstrap(COP_BOOTSTRAP_OPTS);
  } else {
    throw new Error(`Unknown ENTRY: ${ENTRY}`);
  }
};

const renderShellBasedOnEntry = async () => {
  const { renderShell } = await import(
    /* webpackPreload: true */ "./renderShell"
  );
  let options: RenderShellOpts;
  if (ENTRY === "engage") {
    const { App } = await import("./App");
    options = {
      withoutShadowRoot: false,

      app: App,
    };
  } else if (ENTRY === "mm") {
    const { App } = await import("./messagemedia/App");
    options = {
      withoutShadowRoot: true,
      app: App,
    };
  } else if (ENTRY === "cop") {
    const { WrappedApp: App } = await import("./portals/cop/App");
    options = {
      withoutShadowRoot: false,
      app: App,
    };
  } else {
    throw new Error(`Unknown ENTRY: ${ENTRY}`);
  }
  await renderShell(options);
};

function logVersion() {
  console.log("APP_VERSION:", `shell/${COMMIT_HASH}`);
}

async function main() {
  logVersion();
  try {
    await loadBootstrap();
    await renderShellBasedOnEntry();
  } catch (err) {
    console.error(err);
  }
}

main();
